import * as React from "react";

function SvgDoubleArrows(props) {
  return <svg width="1em" height="1em" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path opacity={0.5} d="M7 10.59L11.58 6 7 1.41 8.41 0l6 6-6 6L7 10.59z" fill="#fff" /><path opacity={0.5} d="M0 10.59L4.58 6 0 1.41 1.41 0l6 6-6 6L0 10.59z" fill="#fff" /></svg>;
}

export default SvgDoubleArrows;